import type { ComponentType } from "react";
import type { CustomPayload } from "../types";
import { CompostSimulator } from "../hero/CompostSimulator";

/**
 * Registry of "hero" missions implemented as pure-code React components.
 * Keyed by `payload.component_id` (e.g. "ahimsa.compost_simulator.v1").
 *
 * To add a new hero mission:
 *   1) Create the component under src/hero/.
 *   2) Register it here with a stable id (include a version suffix).
 *   3) In the backend, set MissionRevision.payload to
 *      { "renderer": "custom", "component_id": "<id>", "props": {…}, "passing_score": … }.
 */
type HeroProps = {
  passingScore: number;
  props: Record<string, unknown>;
  onScored: (result: { score: number; passed: boolean; raw: unknown }) => void;
};

const REGISTRY: Record<string, ComponentType<HeroProps>> = {
  "ahimsa.compost_simulator.v1": CompostSimulator as unknown as ComponentType<HeroProps>,
};

interface Props {
  payload: CustomPayload;
  onScored: (result: { score: number; passed: boolean; raw: unknown }) => void;
}

export function CustomRunner({ payload, onScored }: Props) {
  const Comp = REGISTRY[payload.component_id];
  if (!Comp) {
    return (
      <div style={{ padding: 16 }}>
        <p>
          Hero mission no registrada: <code>{payload.component_id}</code>
        </p>
        <p style={{ fontSize: 13, color: "#6b7280" }}>
          Para añadirla, edita <code>src/runners/CustomRunner.tsx</code>.
        </p>
      </div>
    );
  }
  return (
    <Comp
      passingScore={payload.passing_score}
      props={payload.props}
      onScored={onScored}
    />
  );
}
